import { useLayoutEffect } from "react"

export const useKeyEnter = (props: {
  id: string
  onPressEnter?: () => void
}) => {
  const { id, onPressEnter } = props
  useLayoutEffect(() => {
    if (onPressEnter) {
      const input = document.getElementById(id)
      const fn = (e) => {
        if (e.key === "Enter") {
          onPressEnter?.()
        }
      }
      input?.addEventListener("keydown", fn)
      return () => {
        input?.removeEventListener("keydown", fn)
      }
    }
  }, [id, onPressEnter])
}
